'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _slide = require('@dekk/slide');

var _slide2 = _interopRequireDefault(_slide);

var _speakerNotes = require('@dekk/speaker-notes');

var _speakerNotes2 = _interopRequireDefault(_speakerNotes);

var _fragment = require('@dekk/fragment');

var _fragment2 = _interopRequireDefault(_fragment);

var _warning = require('./warning');

var _warning2 = _interopRequireDefault(_warning);

var _components = require('./components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a component that displays a warning about an invalid
 * child component.
 * @private
 * @param {ReactComponent} child
 *   Can be any react component
 * @param {number} index
 *   Used to generate the key property
 * @param {Object} itemProps
 *   The original props of the parent
 * @returns {Warning}
 *   An invalid component warning
 */
var invalid = function invalid(child, index, itemProps) {
  return _react2.default.createElement(
    'div',
    { key: 'slot__' + index, 'data-slot': child.name },
    _react2.default.createElement(_warning2.default, _extends({}, itemProps, {
      type: child.type && (child.type.displayName || child.type.name) || '"' + child + '"',
      invalid: true
    }))
  );
};

/**
 * Renders a component that displays a warning about an invalid
 * child component.
 * @private
 * @param {String} name
 *   Name of the Slot
 * @param {number} index
 *   Used to generate the key property
 * @param {Object} itemProps
 *   The original props of the parent
 * @returns {Warning}
 *   A missing component warning
 */
var missing = function missing(name, index, itemProps) {
  return _react2.default.createElement(
    'div',
    { key: 'slot__' + index, 'data-slot': name },
    _react2.default.createElement(_warning2.default, _extends({}, itemProps, { missing: true }))
  );
};

/**
 * Either renders a component defined in the `only` parameter
 * or returns a warning in case the child does not match the accepted
 * types.
 * @private
 * @param {ReactComponent[]} only
 *   A list of ReactComponents that are allowed
 * @param {ReactComponent} child
 *   The child element that is intended to be added
 * @param {number} index
 *   Used to generate the key property
 * @param {Object} itemProps
 *   The original props of the parent
 */
var onlyOrWarning = function onlyOrWarning(only, child, index, itemProps) {
  // Check if child is allowed
  if (only.includes(child.type)) {
    return child;
  }
  // In case the child is a fragment, check all child elements
  if (child.type === _fragment2.default || child.type === _fragment.FragmentRoot) {
    return (0, _react.cloneElement)(child, {
      children: _react.Children.toArray(child.props.children).map(function (child, i) {
        return onlyOrWarning(only, child, index * 100 + i, itemProps);
      })
    });
  }
  return invalid(child, index, itemProps);
};

/**
 * Either renders a component not defined in the `not` parameter
 * or returns a warning in case the child matches the unaccepted
 * types.
 * @private
 * @param {ReactComponent[]} not
 *   A list of ReactComponents that are not allowed
 * @param {ReactComponent} child
 *   The child element that is intended to be added
 * @param {number} index
 *   Used to generate the key property
 * @param {Object} itemProps
 *   The original props of the parent
 */
var notOrWarning = function notOrWarning(not, child, index, itemProps) {
  if (child.type === _fragment2.default || child.type === _fragment.FragmentRoot) {
    return (0, _react.cloneElement)(child, {
      children: _react.Children.toArray(child.props.children).map(function (child, i) {
        return notOrWarning(not, child, index * 100 + i, itemProps);
      })
    });
  }
  if (not.includes(child.type)) {
    return invalid(child, index, itemProps);
  }
  return child;
};

/**
 * This component is hte heart of Dekk/master.
 * It will filter different content types and evaluate based on the
 * configuration.
 *
 * Invalid or missing slots are marked with a visual error to allow
 * creating slides on very strict guidelines.
 *
 * **A master can have different use cases:**
 *
 * * resrict layout of slides
 * * render static components by default
 * * predefine a layout/styles
 * * provide an easy API/usage
 *
 * This class should not be used. It is used inside `createMaster`
 * @see {createMaster}
 *
 * @private
 * @param {Object} props
 *   The properties
 * @param {ReactElement,ReactElement[]} props.children
 *   The slots injected by the slide creator (developer/user)
 * @param {ReactElement,ReactElement[]} props.content
 *   The children injected by the createMaster function (internal/private)
 */

var Master = function (_Component) {
  _inherits(Master, _Component);

  function Master() {
    _classCallCheck(this, Master);

    return _possibleConstructorReturn(this, (Master.__proto__ || Object.getPrototypeOf(Master)).apply(this, arguments));
  }

  _createClass(Master, [{
    key: 'render',


    /**
     * @private
     */
    value: function render() {
      /**
       * Return a slide with the entire content.
       */
      return _react2.default.createElement(
        _slide2.default,
        this.props,
        this.filledStatics,
        this.filledSlots,
        this.notes
      );
    }
  }, {
    key: 'slots',

    /**
     * All `Slot` instances
     * @private
     */
    get: function get() {
      return _react.Children.toArray(this.props.children).filter(function (child) {
        return child.type === _components.Slot;
      });
    }

    /**
     * All `Static` instances
     * @private
     */

  }, {
    key: 'statics',
    get: function get() {
      return _react.Children.toArray(this.props.children).filter(function (child) {
        return child.type === _components.Static;
      });
    }

    /**
     * Helper slots are filtered from the children.
     * These slots are allowed and will be ignored.
     * state setters, notes etc should be added here
     * @private
     */

  }, {
    key: 'helperSlots',
    get: function get() {
      return [_speakerNotes2.default];
    }

    /**
     * Filtered children of the component.
     * Excludes helperSlots
     * @private
     */

  }, {
    key: 'content',
    get: function get() {
      var _this2 = this;

      return _react.Children.toArray(this.props.content).filter(function (child) {
        return !_this2.helperSlots.includes(child.type);
      });
    }

    /**
     * Filtered notes of the slide.
     * @private
     */

  }, {
    key: 'notes',
    get: function get() {
      return _react.Children.toArray(this.props.content).filter(function (child) {
        return child.type === _speakerNotes2.default;
      });
    }

    /**
     * Fill all static slots.
     * Adds a wrapping element with a data-attribute.
     */

  }, {
    key: 'filledStatics',
    get: function get() {
      return this.statics.map(function (item, i) {
        return _react2.default.createElement(
          'div',
          { key: 'static__' + i, 'data-static': item.props.name },
          item.props.children
        );
      });
    }

    /**
     * Fill all slots.
     * Checks validity and injects a warning in case of an error
     * @private
     */

  }, {
    key: 'filledSlots',
    get: function get() {
      var _this3 = this;

      return this.slots.map(function (item, i) {
        var _item$props = item.props,
            only = _item$props.only,
            not = _item$props.not,
            required = _item$props.required,
            component = _item$props.component,
            name = _item$props.name;
        // Get the index of the component inside slot

        var index = _this3.content.map(function (child) {
          return child.type;
        }).indexOf(component);

        // If no component present either return null
        // or a warning if the slot requires a child.
        if (index < 0) {
          return required ? missing(name, i, item.props) : null;
        }
        var children = _react.Children.toArray(_this3.content[index].props.children).map(function (child, idx) {
          return (
            // Check for `only` and `not` options
            // If neither is defined simply return the child
            only ? onlyOrWarning(only, child, idx, item.props) : not ? notOrWarning(not, child, idx, item.props) : child
          );
        });
        // If no children exist in a required slot
        // render a warning about missing content
        if (required && children.length === 0) {
          return missing(name, i, item.props);
        }

        // Return the components wrapped in a slot.
        return _react2.default.createElement(
          'div',
          { key: 'item__' + i, 'data-slot': item.props.name },
          children
        );
      })
      // Filter to only return valid content
      .filter(function (x) {
        return Boolean(x);
      });
    }
  }]);

  return Master;
}(_react.Component);

/**
 * Allowed propTypes for `<Master/>`
 * @private
 * @property {Slot,Static} children
 * @property {ReactElement,ReactElement[]} content
 */


Master.propTypes = {
  children: function children(props, propName) {
    /**
     * An error might be caused and is therefore returned .
     */
    var error = new Error('"Master" only accepts children of type "Slot" or "Static"');
    var hasErrors = Boolean(_react.Children.toArray(props[propName]).map(function (child) {
      if (![_components.Static, _components.Slot].includes(child.type)) {
        return error;
      }
      return child;
    }).filter(function (x) {
      return x === error;
    }).length);
    return hasErrors ? error : null;
  },
  content: _propTypes2.default.node
};

Master.defaultProps = {
  children: '',
  content: ''
};

exports.default = Master;